document.addEventListener('alpine:init', () => {
  Alpine.data('recentlyViewed', (el) => ({
    // ——— State from data-attributes ———
    max:       parseInt(el.dataset.count)       || 8,
    show:      parseInt(el.dataset.show)        || 8,
    current:   el.dataset.productHandle         || '',

    // ——— Internal state ———
    handles:   [],
    loading:   false,
    list:      null,
    canScrollPrev: false,
    canScrollNext: false,
    progress:     0,
    slideWidth:   0,
    visibleCount: 1,

    // NEW: Drawer içinde mi?
    inDrawer: false,

    _initialized: false,

    init() {
      if (this._initialized) return;
      this._initialized = true;

      // NEW: Cart Drawer içinde mi?
      this.inDrawer = !!el.closest('[id^="GA-Cart-Drawer-"]');

      this.list = this.$refs.list;
      this._saveToLocal();
      this._loadHandles();
      this._fetchCards().then(() => {
        this.update();
        this.list.addEventListener('scroll', () => this.update());
        window.addEventListener('resize',  () => this.update());
      });
    },

    _saveToLocal() {
      if (!this.current) return;
      const key = 'recently-viewed';
      let arr = JSON.parse(localStorage.getItem(key) || '[]');
      arr = [this.current, ...arr.filter(h => h !== this.current)];
      arr = arr.slice(0, 20);
      localStorage.setItem(key, JSON.stringify(arr));
    },

    _loadHandles() {
      const arr = JSON.parse(localStorage.getItem('recently-viewed') || '[]');
      this.handles = arr.filter(h => h !== this.current).slice(0, this.max);
    },

    async _fetchCards() {
      if (!this.handles.length) return;
      this.loading = true;
      this.list.innerHTML = '';
      const seen = new Set();
      let count = 0;

      // Template view: search.ga-card-product.liquid
      const root       = window.Shopify?.routes?.root       || '/';
      const searchBase = window.Shopify?.routes?.search_url || `${root}search`;

      // Width sınıfı sabitleri
      const MOBILE_2COL_WIDTH = 'ga:[width:calc((100%-theme(spacing.4))/2)]';
      const SM_3COL_WIDTH     = 'ga:sm:[width:calc((100%-theme(spacing.4)*2)/3)]';
      const LG_4COL_WIDTH     = 'ga:lg:[width:calc((100%-theme(spacing.4)*3)/4)]';
      // Drawer için her boyutta 3’lü (ul’de gap-2 kullandığın için spacing.2)
      const DRAWER_3COL_WIDTH = 'ga:[width:calc((100%-theme(spacing.2)*2)/3)]';

      for (const handle of this.handles) {
        if (count >= this.show) break;
        const url = `${searchBase}?view=ga-card-product&type=product&q=${encodeURIComponent('handle:' + handle)}`;
        try {
          const res  = await fetch(url, { credentials: 'same-origin' });
          const html = await res.text();
          const tmp  = document.createElement('div');
          tmp.innerHTML = html;

          const li = tmp.querySelector(`li[data-handle="${handle}"]`);
          if (li && !seen.has(handle)) {
            seen.add(handle);

            li.classList.add('ga:flex-none', 'ga:snap-start');

            if (this.inDrawer) {
              li.classList.remove(MOBILE_2COL_WIDTH, SM_3COL_WIDTH, LG_4COL_WIDTH);
              li.classList.add(DRAWER_3COL_WIDTH);
            } else {
              li.classList.add(MOBILE_2COL_WIDTH, SM_3COL_WIDTH, LG_4COL_WIDTH);
            }

            this.list.appendChild(li);
            count++;
          }
        } catch (e) {
          console.error('recent fetch error for', handle, e);
        }
      }

      if (this.list.children.length) {
        el.classList.remove('ga:hidden');
      }
      this.loading = false;
    },

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.list;
      this.canScrollPrev = scrollLeft > 0;
      this.canScrollNext = scrollLeft + clientWidth < scrollWidth - 1;

      if (scrollWidth > 0) {
        const filled = scrollLeft + clientWidth;
        this.progress = Math.min((filled / scrollWidth) * 100, 100);
        this.slideWidth   = this.list.querySelector('li')?.clientWidth || clientWidth;
        this.visibleCount = Math.floor(clientWidth / this.slideWidth) || 1;
      } else {
        this.progress = 0;
      }
    },

    prev() { this.list.scrollBy({ left: -this.slideWidth * this.visibleCount, behavior: 'smooth' }); },
    next() { this.list.scrollBy({ left:  this.slideWidth * this.visibleCount, behavior: 'smooth' }); }
  }));
});